import $http from '@Config/axios';
import $store from '@Store';
import { buildQueryParams } from 'luiz-fns';
import { DefaultPresenter } from './default-presenter';

const prefix = 'box';
const entity = 'Box';

export const BoxPresenter = {
	...DefaultPresenter({ prefix, entity }),
	show(id) {
		return new Promise((resolve, reject) => {
			$http.get(`${prefix}/${id}`)
				.then(response => {
					response.medicamentos_nfe = JSON.parse(response.medicamentos_nfe || '[]');
					resolve(response);
				})
				.catch(response => reject(response));
		});
	},
	/**
	 * @param {Number} boxId
	 *
	 * @param {object} endereco
	 * @param {String} endereco.cep
	 * @param {String} endereco.logradouro
	 * @param {String|Number} endereco.numero
	 * @param {String} endereco.bairro
	 * @param {String|null} endereco.complemento
	 * @param {String|null} endereco.instrucoes_entrega
	 * @param {String} endereco.cidade
	 * @param {String} endereco.estado
	 * @param {String | null} endereco.longitude
	 * @param {String | null} endereco.longitude
	 * @returns
	 */
	atualizarEndereco: (boxId, endereco) => {
		const body = {
			cep: endereco.cep,
			logradouro: endereco.logradouro,
			numero: endereco.numero,
			bairro: endereco.bairro,
			cidade: endereco.cidade,
			estado: endereco.estado,
			complemento: endereco.complemento || null,
			longitude: endereco.longitude || null,
			latitude: endereco.latitude || null,
			instrucoes_entrega: endereco.instrucoes_entrega || null
		};

		return $http.put(`${prefix}/${boxId}/endereco`, body);
	},
	/**
	 * @param {Number} boxId
	 * @returns
	 */
	getBoxMedicines: boxId => $http.get(`${prefix}/${boxId}/box-medicamentos`),
	getAproveitamentoReceita: id => $http.get(`${prefix}/${id}/aproveitamentoReceitas`),
	updateAproveitamentoReceita: (id, params) => $http.post(`${prefix}/${id}/aproveitamentoReceitas`, params),
	updateObservacao: (box_id, observacao) => $http.put(`${prefix}/${box_id}/observacao`, { observacao }),
	ocorrencias: id => $http.get(`${prefix}/${id}/ocorrencias`),
	cobrancaProporcional: id => $http.get(`${prefix}/${id}/cobranca/proporcional`),
	cobrancaIntegral: id => $http.get(`${prefix}/${id}/cobranca/integral`),
	reset: params => $http.patch(`${prefix}/${params.id}`, params),
	index: (params = {}) => $http.get(buildQueryParams(`${prefix}`, { ...params, visao_colaborador: $store.getters.visao_colaborador ? 1 : 0 })),
	gerarEtiquetas: params => $http.get(buildQueryParams(`${prefix}/etiquetas`, params)),
	count: () => $http.get(`${prefix}/count`),
	fetchCobrancas: params => $http.get(`${prefix}/fetchCobrancas`, params),
	fetchCompras: params => $http.get(`${prefix}/fetchCompras`, params),
	fetchRT: params => $http.get(`${prefix}/fetchRT`, params),
	fetchSucesso: params => $http.get(`${prefix}/fetchSucesso`, params),
	receitas: box_id => $http.get(`${prefix}/${box_id}/receitas`),
	medicamentos: box_id => $http.get(`${prefix}/${box_id}/medicamentos`),
	listaDeCompras: ({ ids }) => $http.get(buildQueryParams(`${prefix}/listaDeCompras`, { ids })),
	gerarPdfPicking: ({ ids }) => $http.get(buildQueryParams(`${prefix}/gerarPdfPicking`, { ids })),
	gerarPdfOrdemDeProducao: box_id => $http.get(buildQueryParams(`${prefix}/${box_id}/gerarPdfOrdemDeProducao`)),
	gerarPdfPickingEOrdemDeProducao: ({ ids }) => $http.get(buildQueryParams(`${prefix}/gerarPdfPickingEOrdemDeProducao`, { ids })),
	getBoxTraceability: boxId => $http.get(`${prefix}/${boxId}/rastreabilidade`)
};
